import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../../../../services/api';

export function useXeroDepositToAccounts() {
  return useQuery(['xeroDepositToAccounts'], async () => {
    const api = getPrivateApi();
    const response = await api.xeroGetDepositToAccounts();
    return response.depositToAccounts;
  });
}
